import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import { closest } from 'next/javascripts/modules/dom';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-project-timeline-point', {
  mixins: [eventListenerMixin],

  properties: {
    url: String,
    category: String,
  },

  connected() {
    this.todo = closest(this, 'tr-project-timeline-todo');
    this.initDrag();
  },

  initDrag() {
    $(this).draggable({
      cursor: 'move',
      revert: true,
      revertDuration: 0,
      accept: '.timeline-todo-wrapper',
      start: this.handleDragStart.bind(this),
      drag: this.handleDrag.bind(this),
      stop: this.handleDragStop.bind(this),
    });
  },

  handleDragStart(event, ui) {
    this.insertAdjacentHTML(
      'beforeend',
      '<svg class="point-line" xmlns="http://www.w3.org/2000/svg"><path></path></svg>',
    );
    this.svg = this.todo.querySelector('.point-line');
    this.path = this.todo.querySelector('.point-line path');
    this.origin = ui.position;
  },

  handleDrag(event, ui) {
    const { top, left } = ui.position;
    const diff = this.category === 'parent' ? 28 : 0;
    this.svg.style.width = Math.abs(left);
    this.svg.style.height = Math.abs(top);
    this.path.setAttribute(
      'd',
      `M14,14 ${diff + this.origin.left - left},${14 + this.origin.top - top}`,
    );
  },

  handleDragStop(event) {
    this.svg.remove();

    const { target } = event.originalEvent;
    if (!target) return;
    if (!closest(target, '.timeline-todo-wrapper')) return;
    const todo = closest(target, 'tr-project-timeline-todo');

    $.ajax({
      url: this.url,
      type: 'post',
      dataType: 'script',
      data: {
        'todos_dependency[todo_id]': todo.todoGuid,
        'todos_dependency[category]': this.category,
      },
    });
  },

  disconnected() {
    this.stopListening();
  },
});
